import {v4 as uuidv4} from "uuid";
import {faker} from "@faker-js/faker";
import { PRODUCT_ID_WMC } from "../../utils/subscription-plan";
import _ from "lodash";
import { TERRAFORM } from "../../utils/app-constants.json";

export const allBlueprintsCategories = () => {
  return [
    {
      ID: "1807f1ef-fe9d-57f6-95d8-373475acdefgh",
      Name: "Application Blueprints",
    },
    {
      ID: "69153c20-227e-5bc4-87c0-a34462749bcvf",
      Name: "Infrastructure",
    },
    {
      ID: "75d83b36-3247-5cc8-824c-0de8f10qqqqq",
      Name: "VPC Blueprints",
    },
    {
      ID: "a79383fa-90bc-5d73-94d7-30f377qqwwd",
      Name: "Server Blueprints",
    },
    {
      ID: "bb63c400-d61d-50ad-bf9d-c0df84mnbhjl",
      Name: "Cluster Blueprints",
    },
  ];
};

const category = allBlueprintsCategories().map(({ Name }) => Name);
const owner = ["MontyCloud", "AWS"];
const type = ["CFN", "Terraform"]; //"Seaplane" can be added later if required.

export const TERRAFORM_DRAFT_BP_ID =
  "dc3bbf77bf67-ace2-8a0e-5a7c-ffd4831fUibdw";
export const TERRAFORM_COMPLETED_BP_ID =
  "dc3bbf77bf67-ace2-8a0e-5a7c-ffd4831fUib12";
export const TERRAFORM_BP_ID = "dc3bbf77bf67-ace2-8a0e-5a7c-ffd4831fUibdw";

export const CREATE_TERRAFORM_BP_ID = "1896540c-a479-4626-8035-34bf3fdfd704";

export const createBlueprint = (bp) => {
  const {
    metadata: { name, description, type },
  } = bp;
  const blueprint = {
    Name: name,
    Description: description,
    BlueprintId: uuidv4(),
    Category: faker.helpers.arrayElement(category),
    Type: type,
    Depts: [],

    Owner: "Customer",
  };
  return blueprint;
};

export const allBlueprints = (deptIds = null) => {
  let allBlueprints = [
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "0267d952-ab17-54ec-9e5b-b11af1285f4d",
      Category: "Cluster Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Perform ECS Fargate blue/green deployments through CodeDeploy using AWS CloudFormation",
      InScope: false,
      Name: "ECS Fargate blue/green deployment through CodeDeploy",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/fargate_bg/fargate_bg_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },

    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
      Category: "Application Blueprints",
      CostEstimate: "40",
      CostEstimateId: "8b48fbcc-bd0b-4d80-b593-e3158fe78566",
      Description:
        "Build DAY2 ready Server Apps. Import any Windows/Linux Server based apps and automatically enable HA, network connectivity, fault tolerance, auto scaling, monitoring and ops automation along with security best practices",
      InScope: false,
      Name: "Transform Server Apps for Cloud and Ops Readiness",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/byoa_ha/byoa_ha_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "0b29c85a-5947-50c5-8ab0-6c242d491ab5",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Amazon S3 Intelligent Tiering Service delivers the first cloud storage that automatically reduces your storage costs on a granular object level by automatically moving data to the most cost-effective access tier based on access frequency, without performance impact, retrieval fees, or operational overhead. This Storage is ideal for any workload, especially data lakes, data analytics, new applications, and user-generated content.",
      InScope: false,
      Name: "Storage Service Intelligent Tiering",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_intelligenttiering/StorageServiceIntelligentTiering.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "0c17105c-5a9d-5888-a3a1-49886721bcaa",
      Category: "Infrastructure",
      CostEstimate: "0",
      CostEstimateId: "63ade1aa-0c37-4f65-8cb0-6423f44619b1",
      Description:
        "This Blueprint creates Dynamodb tables with an application auto-scaling that scales up the read and write capacity units throughput, which will enable customers to reduce the complexities of manual setup.",
      InScope: false,
      Name: "Setup DynamoDB",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/dynamodb/dynamodb_permission.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "0d456be2-7762-5fde-a5f5-dd6aac168778",
      Category: "High Performance Computing",
      CostEstimate: "8.5",
      CostEstimateId: "ae3d76de-62ae-4d85-8de9-b096cff7d6b0",
      Description:
        "This Blueprints deploys all the required Infrastructure for running HPC workloads on AWS by using ParallelCluster. AWS ParallelCluster is an AWS-supported open source cluster management tool that makes it easy for you to deploy and manage High Performance Computing (HPC) clusters on AWS.",
      InScope: true,
      Name: "High Performance Computing using Slurm",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/hpc_parallelcluster/hpc_parallelcluster_permission.yaml",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
      Depts: ["31rba91b7-551f-4d35-a113-b37fcd840a71"],
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "10d9a58e-3cc8-51ee-bfd9-8d39da171138",
      Category: "Cluster Blueprints",
      CostEstimate: "330",
      CostEstimateId: "fe761ce1-8c32-4634-a735-c5d4517c91e6",
      Description:
        "Provisions a highly available, fault-tolerant ElasticSearch cluster with Network Load Balancer, and the required number of master and data nodes.",
      InScope: false,
      Name: "ElasticSearch",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/elasticsearch_nlb/elasticsearch_permission.yaml",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "13f4e9a7-0edd-5d25-8009-11a5f561a326",
      Category: "High Performance Computing",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "This Blueprints deploys all the required Infrastructure for running HPC workloads on AWS by using ParallelCluster. AWS ParallelCluster is an AWS-supported open source cluster management tool that makes it easy for you to deploy and manage High Performance Computing (HPC) clusters on AWS.",
      InScope: false,
      Name: "AWS ParallelCluster Sample 1",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/hpc_parallelcluster/hpc_parallelcluster_permission.yaml",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "1572391e-89c9-5235-97c3-59d77b9e84e3",
      Category: "Application Blueprints",
      CostEstimate: "8.5",
      CostEstimateId: "b15fcf4b-cf2d-4fc8-b234-1762a6cbc182",
      Description:
        "Setup a Load Test Environment with Apache JMeter on Amazon EC2",
      InScope: false,
      Name: "Setup JMeter",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/jmeter_app/jmeter_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "192f2c8a-6262-5a25-a773-f6a395fbcdc1",
      Category: "Serverless",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Create an API Gateway endpoint authenticated by a Cognito Authorizer backed by a Cognito User pool proxied with a Lambda Function.",
      InScope: false,
      Name: "Serverless Architecture Type 1",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/serverless_type1/serverlessarchitecturetype1_permission.json",
      SubCategory: "API",
      SupportedProducts: null,
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "1f4af570-4ca4-53b0-9ee1-1d61228369b6",
      Category: "Infrastructure",
      CostEstimate: "28.66",
      CostEstimateId: "b3e14a2e-7b63-41de-bf2c-268fe733f22d",
      Description:
        "Creates a RDS Database having an Engine of type PostgreSQL 11.6 with a parameter group associated with the DB Instance. A Read Replica can also be enabled",
      InScope: false,
      Name: "RDS PostgreSQL",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/postgresql/rds_postgresql_permission.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "24e69f99-d5a2-5a69-a2ac-babc2d6dbdca",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Amazon S3 standard service delivers low latency and high throughput for frequently accessed data. Designed for high durability, availability, and performance object storage, This Storage is appropriate for a wide variety of use cases, including cloud applications, dynamic websites, content distribution, mobile and gaming applications, and big data analytics",
      InScope: true,
      Name: "Storage Service Standard",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_standard/StorageServiceStandard.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "29028135-5a54-5409-8081-8bd1c2eec2a3",
      Category: "Cluster Blueprints",
      CostEstimate: "0",
      CostEstimateId: "1302184a-832e-466b-aec5-3ee6ff5f38d6",
      Description:
        "Deploys a Fargate Cluster and build your applications with ECS",
      InScope: false,
      Name: "Fargate Cluster Service",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/fargate/fargate_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "2ed84a19-39ef-56c7-9ded-2fb5ed877c6d",
      Category: "Infrastructure Blueprint",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Creates the infrastructure for deploying EC2 Spot Instances.",
      InScope: true,
      Name: "EC2 Spot Instance",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/ec2spotinstance/ec2spotinstance_permission.json",
      SubCategory: "Networking, Security & Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "31023c1e-969f-5347-a7cf-0398e8a521e1",
      Category: "Server Blueprints",
      CostEstimate: "366",
      CostEstimateId: "43443c5f-d39e-4ad7-95db-6cc612e56200",
      Description: "Provisions an Amazon Redshift cluster.",
      InScope: false,
      Name: "Redshift Cluster",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/redshift/redshift_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["b3acb8d7-47c6-5df2-8996-7daca76f6ad0"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "326d7cf5-9f6f-5170-85c8-2d1719bd3ec7",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Storage Service Glacier Flexible Retrival blueprints delivers low-cost storage, up to 10% lower cost (than S3 Glacier Instant Retrieval), for archive data that is accessed 1\u20142 times per year and is retrieved asynchronously.",
      InScope: false,
      Name: "Storage Service Glacier Flexible Retrival",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_glacierflexibleretrival/StorageServiceGlacierFlexibleRetrival.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "338f3c2d-54d7-5c30-854d-a0c6098bf94a",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Artificial intelligence based protein folding program that predict the structure of unknown peptide sequences",
      InScope: true,
      Name: "AlphaFold Compute Environment",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/alphafold_compute_environment/AlphaFoldComputePermission.json",
      SubCategory: "Compute",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
      Depts: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "34670835-d636-575b-9432-2238689b1065",
      Category: "Application Blueprints",
      CostEstimate: "0",
      CostEstimateId: "22022157-2425-4341-b37a-ddbcb830fb81",
      Description:
        "Creates the infrastructure for hosting a Static Website behind CloudFront.",
      InScope: false,
      Name: "Static WebSite Hosting",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/staticwebsite/staticwebsite_permission.json",
      SubCategory: "Networking, Security & Storage",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "354a6788-5d3a-5669-83c7-cad61c460249",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "This template deploys the cloudformation stack to set up AWS Client Managed VPN endpoint to access the EC2 instance located in the private subnet directly from your local machine.",
      InScope: false,
      Name: "Setup AWS Managed Client VPN",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/awsclientvpn/aws_client_vpn_permission.json",
      SubCategory: "Networking",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "3c4b35c6-03f8-5664-be7a-8df19f8331f7",
      Category: "Application Blueprints",
      CostEstimate: "8.5",
      CostEstimateId: "11a1016e-a606-4dec-aae7-3e86f6d9b074",
      Description:
        "This Blueprint creates an EC2 instance with Tomcat Web Server installed",
      InScope: false,
      Name: "Tomcat Web Server",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/tomcat/tomcat_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "466eba3e-e766-54c4-8f8e-b83b025ac082",
      Category: "Application Blueprints",
      CostEstimate: "8.5",
      CostEstimateId: "d566a318-1835-47d8-ba91-bb183075a580",
      Description:
        "This Blueprint creates an EC2 instance with Apache Web Server installed",
      InScope: false,
      Name: "Apache Web Server",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/apache_web_server/apache_web_server_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "499436aa-9349-5e75-a4b6-18dce7eb7aa8",
      Category: "Application Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description: "Sets up Cost And Usage report",
      InScope: false,
      Name: "CUR Setup",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/cur_report/cur_permission.json",
      SubCategory: "Cost, View",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "4e189646-950f-5775-b857-86393265fb28",
      Category: "Server Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description: "Provisions EC2 Instance(s) with VerneMQ configurations",
      InScope: false,
      Name: "VerneMQ Cluster",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/ec2_vernemq/ec2_vernemq_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["b3acb8d7-47c6-5df2-8996-7daca76f6ad0"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "4feb5438-af67-54af-b4e6-dc820f6c5142",
      Category: "Application Blueprints",
      CostEstimate: "0",
      CostEstimateId: "f6d71c79-e0ef-4d00-914c-36830c4bb506",
      Description:
        "Creates the infrastructure for hosting a Static Website behind CloudFront.",
      InScope: false,
      Name: "Static Website Hosting",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/staticwebsite/staticwebsite_permission.json",
      SubCategory: "Networking, Security & Storage",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "542aba8d-e0e4-5fd7-a29e-215514ce6488",
      Category: "High Performance Computing",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "This Blueprints deploys all the required Infrastructure for running HPC workloads on AWS by using ParallelCluster. AWS ParallelCluster is an AWS-supported open source cluster management tool that makes it easy for you to deploy and manage High Performance Computing (HPC) clusters on AWS.",
      InScope: false,
      Name: "AWS ParallelCluster Sample 2",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/hpc_parallelcluster_2/hpc_parallelcluster_2_permission.yaml",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "5641d8df-bb3e-5764-9e20-f5f247d1d014",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "This Template deploys the cloudformation stack to set up a latest version of Open VPN Access server on top on EC2 instance access the servers in private subnet without using a bastion host or jump server from the local machine directly.",
      InScope: false,
      Name: "Setup OpenVPN Access Server",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/openvpn/openvpn_permission.json",
      SubCategory: "Networking",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "58d798e5-198a-50b0-af5c-0518ab815f42",
      Category: "Application Blueprints",
      CostEstimate: "357",
      CostEstimateId: "24279b34-eb58-4b34-bd6f-de3769e98c42",
      Description:
        "Creates an EMR spark based HBase cluster which runs on top of Amazon S3 (EMRFS) instead of HDFS data storage.",
      InScope: false,
      Name: "ElasticMap Reduce",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/emr/emr_permission.json",
      SubCategory: "Analytics",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "5e96ab29-abeb-56e1-b8f1-cf1895488199",
      Category: "Server Blueprints",
      CostEstimate: "8.5",
      CostEstimateId: "ba8ff0dd-565e-46a0-ab9d-8fc939fda5cf",
      Description:
        "Provisions a Windows EC2 Instance with Windows Server 2016 and 2019 options.",
      InScope: false,
      Name: "EC2 Windows Instance",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/ec2instance_windows/ec2instance_windows_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["b3acb8d7-47c6-5df2-8996-7daca76f6ad0"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "5f5c6a5c-bc3a-5d79-b8e0-2f54f4a0f94e",
      Category: "MinimumViableCloud",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Creates a new AWS account and deploy the minimum viable cloud resources within this new environment.",
      InScope: false,
      Name: "Account Vending Machine with Minimum Viable Cloud Deployment",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/minimum_viable_cloud/mvc_permissions.json",
      SubCategory: "Infrastructure",
      SupportedProducts: null,
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "61e0bca9-6336-5c70-bcdb-77c0bd5c7444",
      Category: "Application",
      CostEstimate: null,
      CostEstimateId: null,
      Description: "Install nginx as a web server on EC2 Linux instance.",
      InScope: false,
      Name: "Nginx Load Balancer on EC2",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/nginx_app/nginx_app_permissions.json",
      SubCategory: "Load balancer",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "631ac820-5fc8-5013-8d4c-283059b54254",
      Category: "Application Blueprints",
      CostEstimate: "40",
      CostEstimateId: "ef40786c-9e24-4ac7-9183-0848fb1950ea",
      Description:
        "Build DAY2 ready Server Apps. Import any Windows/Linux Server based apps and automatically enable HA, network connectivity, fault tolerance, auto scaling, monitoring and ops automation along with security best practices",
      InScope: false,
      Name: "Transform Server Apps for Cloud and Ops Readiness",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/byoa_ha/byoa_ha_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "64ca6daf-804d-5fb1-b153-46463f822ebb",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Storage Service IA blueprints is for data that is accessed less frequently, but requires rapid access when needed.",
      InScope: false,
      Name: "Storage Service Standard IA",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_standard_IA/StorageServiceStandardIA.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "67f289c8-dcd3-5fb7-8844-75dd02e153c9",
      Category: "Infrastructure",
      CostEstimate: "351.36",
      CostEstimateId: "b9f0dc57-172a-4710-be03-26cf4698f8cb",
      Description:
        "Create an Aurora DB Cluster consisting of single reader and writer. There is an option to choose Aurora version ranging from MySQL, PostgreSQL and the default Aurora",
      InScope: false,
      Name: "Amazon Aurora",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/aurora/aurora_permission.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "69cd0d6a-0b43-5fb7-a518-1068c15d8ece",
      Category: "Application Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Creates the Network and Compute infrastructure for SLU Digital Humanity.",
      InScope: false,
      Name: "SLU Digital Humanity",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/slu-digit-humanity/slu_permission.json",
      SubCategory: "Networking, Security & Storage",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "6e60bf60-5c08-5a60-92aa-b9bc343343fb",
      Category: "Application",
      CostEstimate: "8.5",
      CostEstimateId: "3c1d3f74-874d-45e7-9d16-bea674ffd2a7",
      Description:
        "Install nginx on EC2 Linux instance.It could be used as webserver, reverse-proxy, load balancer",
      InScope: false,
      Name: "NGINX installed on EC2 Linux",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/nginx/nginx_permission.json",
      SubCategory: "Web Server",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "6fde1654-cd1c-5989-aee5-924c3f3f24a8",
      Category: "VPC Blueprints",
      CostEstimate: "0",
      CostEstimateId: "b622ad2f-0d67-4181-b3e4-ccb11ddf9d38",
      Description:
        "Creates a VPC with private subnets across two Availability Zones, NAT Gateway and associated public subnets for NAT gateway traffic, Route Tables and Subnet Route Table Associations.",
      InScope: true,
      Name: "Private VPC",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/vpc_private/vpc_private_permission.json",
      SubCategory: "Networking and Content Delivery",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
      Depts: ["31rba91b7-551f-4d35-a113-b37fcd840a71"],
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "74253a61-108b-5a8f-80f5-8b90479dd19c",
      Category: "Server Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description: "Provisions an EC2 Instance for Jain University",
      InScope: false,
      Name: "Create Classroom",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/createclassroom/createclassroom_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["b3acb8d7-47c6-5df2-8996-7daca76f6ad0"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "75c501c4-0ad0-584f-a0c0-b29fa75712ec",
      Category: "Infrastructure",
      CostEstimate: "27.19",
      CostEstimateId: "3dc7c5a2-cc97-43dc-9c8c-63ae6ceca397",
      Description:
        "Creates a RDS MySQL database with options for engine version ranging from 5.5 to 8.0 . A Master Database is created with an options group and parameter group associated with the DB instance. You can also opt to create a replica database.",
      InScope: false,
      Name: "RDS MySQL",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/rds/rds_permission.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "782e178b-feb6-5306-81d8-3a5648c379b7",
      Category: "Infrastructure Blueprint",
      CostEstimate: "1985",
      CostEstimateId: "14ecbabe-7868-4003-97cb-e1f63348b5d6",
      Description:
        "Informatica BDM is installed and configured on an Amazon EC2 instance during the provision of the nodes from the one-click deployment. The deployment automatically creates the following Informatica services: Domain, Model Repository, Data Integration service and assigns the connection to the Amazon EMR cluster for HDFS, Hive. The Informatica domain and repository database are hosted on Amazon RDS using MS SQL Server which handles management tasks, such as backups, patch management, and replication.",
      InScope: false,
      Name: "Informatica - Big Data Management",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/informatica/informatica_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "7a8e592d-5e37-47ac-877d-c44a817dafc4",
      Category: "Cluster Blueprints",
      CostEstimate: "36.6",
      CostEstimateId: "6fa8530d-04af-4795-a1c7-3df3a04c3aa6",
      Description:
        "Provisions an ElasticSearch Cluster. We recommend users to use the new version of ElasticSearch which offers much more capabilities.",
      InScope: false,
      Name: "Elastic Search - Classic",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/ElasticSearch/ELSPermission.yaml",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "7d462c6c-1118-58c0-95f3-c92654858bd9",
      Category: "High Performance Computing",
      CostEstimate: "54",
      CostEstimateId: "abe3168e-b735-4ad8-bd10-0a59e8b1199e",
      Description:
        "This Blueprints deploys all the required Infrastructure for running HPC workloads on AWS by using AWS Batch that is suitable for running low-priority and high-priority Job Queues.",
      InScope: true,
      Name: "AWS Batch For HPC",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/hpc_awsbatch/hpc_awsbatch_permission.yaml",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
      Depts: ["31rba91b7-551f-4d35-a113-b37fcd840a71"],
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "7d508b0f-9cec-52e6-b7f7-4fd276b26ebd",
      Category: "Cluster Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Performs ECS Fargate Blue/Green Deployment using CodeDeploy",
      InScope: false,
      Name: "ECS Fargate Blue/Green Deployment using CodeDeploy",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/fargate_bg/fargate_bg_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "84c5f11c-af6f-5bf0-97ef-a76b9f03c0bb",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Amazon S3 Glacier Flexible Retrieval service is ideal for archive data that does not require immediate access but needs the flexibility to retrieve large sets of data at no cost, such as backup, disaster recovery, offsite data storage needs. This storage delivers low-cost while designed for 99.999999999% (11 9s) of data durability and 99.99% availability.",
      InScope: false,
      Name: "Storage Service Glacier Flexible Retrieval",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_glacierflexibleretrival/StorageServiceGlacierFlexibleRetrival.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "865bff3f-9a59-5791-9e00-0e930f08ac82",
      Category: "Cluster Blueprints",
      CostEstimate: "104",
      CostEstimateId: "c35ad14f-fc25-46c1-8007-fc187688991d",
      Description:
        "Deploys a Kubernetes cluster using EKS to run containerized applications on Kubernetes on AWS.",
      InScope: false,
      Name: "EKS-Managed Kubernetes Service",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/eks/eks_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "867cc57f-a918-51a0-b386-0c69f68b73ce",
      Category: "Application",
      CostEstimate: "8.51",
      CostEstimateId: "0dd79484-92a9-4e92-9021-16063ffba187",
      Description:
        "eLabFTW is the most popular open source electronic lab notebook for research labs. This Blueprint launches an eLabFTW setup backed by RDS Aurora",
      InScope: true,
      Name: "eLabFTW",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/eLabFTW_app/eLabFTW_app_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
      Depts: ["72ka91b7-551f-4d35-a113-b37fcd840a71"],
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "879ab677-f25b-5925-9c67-5d375a7c05f5",
      Category: "Application Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description: "Sets up Cost And Usage report",
      InScope: false,
      Name: "Cur Setup",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/cur_report/cur_permission.json",
      SubCategory: "Cost, View",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "8af3eacb-92bf-5a5b-8c28-ab492226f12b",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Amazon S3 Infrequent Access Service delivers high durability, high throughput, and low latency for the data that is accessed less frequently but requires rapid access when needed. This Storage is ideal for long-term storage, backups, and as a data store for disaster recovery files.",
      InScope: false,
      Name: "Storage Service Standard Infrequent Access",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_standard_IA/StorageServiceStandardIA.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "8ce6672b-d8ca-5b69-8840-9e45d1fcfe3e",
      Category: "Cluster Blueprints",
      CostEstimate: "36.6",
      CostEstimateId: "84199bb4-0661-4523-ac5d-59d67ba090c1",
      Description:
        "Provisions an ElasticSearch Cluster. We recommend users to use the new version of ElasticSearch which offers much more capabilities.",
      InScope: false,
      Name: "Elastic Search - Classic",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/ElasticSearch/ELSPermission.yaml",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "926a3754-89bb-5d69-a4fd-4116969f0604",
      Category: "Infrastructure",
      CostEstimate: "0",
      CostEstimateId: "c36c806e-2659-42ce-b0ba-3ffdc59fdfe3",
      Description:
        "Creates an Elastic File System with configurable mount-targets protected by a Security Group.",
      InScope: false,
      Name: "EFS",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/efs/efs_permission.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "9319b567-083f-5580-9b06-bcaed162c816",
      Category: "Cluster Blueprints",
      CostEstimate: "104",
      CostEstimateId: "b33a560b-d90d-48be-b016-03f14cc408ff",
      Description:
        "Deploys a Kafka cluster on EKS as a Kubernetes StatefulSet which helps in streaming clickstream data from web applications",
      InScope: false,
      Name: "Kafka on EKS-Managed Kubernetes Service",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/KafkaOnEks/KafkaOnEks_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "94e292b0-21f8-578a-890c-de7e872c0d28",
      Category: "Infrastructure Blueprint",
      CostEstimate: null,
      CostEstimateId: null,
      Description: "Creates the infrastructure for creating S3 bucket.",
      InScope: false,
      Name: "S3 Bucket",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/s3bucket/s3bucket_permission.json",
      SubCategory: "Networking, Security & Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "953bd7ac-44d4-55c6-9f5c-7b42870e27b2",
      Category: "Cluster Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "This blueprint deploys the cloudformation stack to set up an Amazon Elasticache Redis Cluster with cluster mode enabled or disabled based on the user's input.",
      InScope: false,
      Name: "ElastiCache Node/Cluster for Redis ",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/elasticache_redis/elasticache_redis_permission.json",
      SubCategory: "Cluster",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "99cfce45-9650-57d9-9043-0637477f0815",
      Category: "VPC Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Creates a VPC with private subnets across three Availability Zones, NAT Gateway and associated public subnets for NAT gateway traffic, Route Tables and Subnet Route Table Associations.",
      InScope: false,
      Name: "Private VPC (3 AZ's)",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/3az_vpc_private/3az_vpc_private_permission.json",
      SubCategory: "Networking and Content Delivery",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "9a1b46a5-0c82-550c-a092-c6a5c629de8f",
      Category: "Application Blueprints",
      CostEstimate: "562.18",
      CostEstimateId: "5f90eeb7-35b8-4948-b140-24d5f1c485ca",
      Description:
        "This cloud formation template sets up a data management infrastructure pipeline where customers can opt to select which data analysis method they want to use to track and analyze the web traffic of your existing application",
      InScope: false,
      Name: "Tableau Server",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/tableau/tableau_permission.json",
      SubCategory: "Analytics",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "ab719e5e-31aa-58e9-843c-9f3a9f9dbc88",
      Category: "Application Blueprints",
      CostEstimate: "0",
      CostEstimateId: "c483d256-863d-42c0-a5b3-61a9bfc85ba7",
      Description:
        "Blueprint for deployment of the serverless-transit-network-orchestrator Solution for Hub node.",
      InScope: false,
      Name: "Serverless Transit Network Orchestration",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/transitgw/transitgw_permission.json",
      SubCategory: "Networking, Security & Storage",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "b053a609-b73b-5bc7-af60-d01b9467cdbd",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Amazon S3 Glacier Deep Archive Service delivers lowest-cost storage and supports long-term retention and digital preservation for data that may be accessed once or twice in a year. This Storage is designed for particularly those in highly-regulated industries, such as financial services, healthcare, and public sectors\u2014that retain data sets for 7\u201410 years or longer to meet regulatory compliance requirements.",
      InScope: false,
      Name: "Storage Service Glacier Deep Archive",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_glacierdeeparchive/StorageServiceGlacierDeepArchive.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "b5939068-4246-5771-8b62-80f0304f5ee7",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Amazon S3?Glacier Instant Retrieval?Service?is ideal for archive data that needs immediate access, such as medical images, news media assets, or user-generated content archives. This Storage delivers lowest cost for long-lived data that is rarely accessed and requires retrieval in milliseconds.",
      InScope: false,
      Name: "Storage Service Glacier Instant Retrival",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_glacierinstantretrival/StorageServiceGlacierInstantRetrival.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "bbe4019e-158f-5d37-ba55-8a0fb0836af4",
      Category: "Server Blueprints",
      CostEstimate: "8.5",
      CostEstimateId: "78b2e5c5-e425-4553-82db-5005aba72b8a",
      Description:
        "Provisions an EC2 Instance with flavors of Linux ranging from Amazon Linux, Amazon Linux 2, RHEL 8, Ubuntu and SUSE",
      InScope: true,
      Name: "EC2 Linux Instance",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/ec2instance_linux/ec2instance_linux_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["b3acb8d7-47c6-5df2-8996-7daca76f6ad0"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "c2755e2f-3408-5e53-b0ab-8f421fed88e5",
      Category: "Infrastructure",
      CostEstimate: "27.19",
      CostEstimateId: "afe65f7f-f624-4fec-8b9b-2c9165ac12fc",
      Description:
        "Creates a RDS DB instance with an engine of type MariaDB 10.3.20 . An Option Group and Parameter Group are also created and associated with the DB instance.A Read Replica can also be enabled.",
      InScope: false,
      Name: "RDS MariaDB",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/mariadb/mariadb_permissions.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "c7dbc39b-af83-5723-b03e-1668924589ed",
      Category: "Operational Excellence",
      CostEstimate: "32",
      CostEstimateId: "1ac6f504-cb92-48b4-8850-a6f1517b7889",
      Description: "This blueprint sets up a highly available Jenkins Master",
      InScope: false,
      Name: "Highly Available Jenkins Master",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/jenkins_app/jenkins_permission.json",
      SubCategory: "DevOps",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Premium",
      AvailableInPlan: false,
      BlueprintId: "cf53957c-2098-528d-b7e2-bef656582db2",
      Category: "Cluster Blueprints",
      CostEstimate: "290",
      CostEstimateId: "b63381fc-394b-49f0-8af4-3512d0426964",
      Description:
        "Deploy an ECS Cluster that is highly scalable, faster, container management service that makes it easy to run, stop, and manage Docker containers on a cluster of Amazon EC2 instances.",
      InScope: false,
      Name: "ECS Cluster",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/ecs_app/ecs_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "df8a21c3-f645-569e-b92d-8f812bb4df9d",
      Category: "Application Blueprints",
      CostEstimate: "8.5",
      CostEstimateId: "354dcbb4-7e67-4705-91a5-cbf1b720bc54",
      Description:
        "Creates an EC2 instance with a Juypter Notebook deployed from the Jupyter Docker Stack Catalog, with an IAM Role for password-less access to S3 buckets and enables the Jupyter Lab feature on boot.",
      InScope: true,
      Name: "Jupyter Notebook",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/jupyter_app/jupyter_permission.json",
      SubCategory: "Data Modelling",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
      Depts: ["72ka91b7-551f-4d35-a113-b37fcd840a71"],
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "e0943cc0-70a9-584e-b21e-79746bd6385b",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Create an Aurora DB Cluster consisting of single reader and writer. There is an option to choose Aurora version ranging from MySQL,PostgreSQL and thedefault Aurora.",
      InScope: false,
      Name: "Amazon Aurora Test",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/aurora/aurora_permission.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "e112237b-58d7-5069-8111-bce6d134e8ea",
      Category: "MinimumViableCloud",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Creates a minimum viable cloud resources to have a secure AWS environment.",
      InScope: false,
      Name: "Minimum Viable Cloud",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/minimum_viable_cloud/mvc_permissions.json",
      SubCategory: "Infrastructure",
      SupportedProducts: null,
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "e4ec2a87-daca-5df2-80d6-d02e4824f9d4",
      Category: "Application Blueprints",
      CostEstimate: "182.5",
      CostEstimateId: "f90cd362-575c-4da2-918d-49803a8e0e42",
      Description:
        "This cloud formation template sets up a data management infrastructure pipeline where customers can opt to select which data analysis method they want to use to track and analyze the web traffic of your existing application",
      InScope: false,
      Name: "Log Analytics",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/loganalytics/loganalytics_permission.json",
      SubCategory: "Analytics",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "e5aa1253-95a2-5a3e-b441-9de8f65682f1",
      Category: "Infrastructure",
      CostEstimate: "33.98",
      CostEstimateId: "73637290-6218-4d83-a932-fa6683b08d61",
      Description:
        "This template provisions AWS infrastructure to reach WordPress 5-minutes install.",
      InScope: false,
      Name: "Wordpress 5-minute install",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/wordpress/wordpress_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "e6177864-dcba-5185-a840-4962d65c80dd",
      Category: "Cluster Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "This template deploys the cloudformation stack to set up Amazon Elasticache Redis Cluster with cluster mode enabled as well as cluster mode disabled respectively based on the input parameters.",
      InScope: false,
      Name: "Setup Elasticache Redis Cluster",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/elasticacheredis/aws_elasticache_redis_permission.json",
      SubCategory: "Cluster",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "e81d8877-b6dc-5bbc-acd1-10ac72b49b6d",
      Category: "Cluster Blueprints",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Sets up an ECS Cluster that is highly scalable, faster with an end to end CI/CD pipeline to automatically build, test, and deploy an application to ECS for every commit to the Github repository.",
      InScope: false,
      Name: "ECS Cluster with complete CI/CD pipeline",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/ecs_cicd/ecs_cicd_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["f9096364-14b9-53cd-b7e1-ac71843b1532"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "e95e2233-7518-5eb1-85b8-a12349555538",
      Category: "Infrastructure",
      CostEstimate: "9",
      CostEstimateId: "3e579704-d282-4b97-b952-0c52465daae1",
      Description:
        "Deploys an DMS pipeline to migrate one Database to another.",
      InScope: false,
      Name: "Data Migration",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/data_migration_service/dms_permission.json",
      SubCategory: "Compute",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "f7e07f34-4991-5c91-96d0-4bbe2768c3c8",
      Category: "VPC Blueprints",
      CostEstimate: "0",
      CostEstimateId: "3068604d-14d4-4181-96e2-104c186bd133",
      Description:
        "Creates a VPC with public-facing subnets across two Availability Zones, Internet Gateway, VPC Gateway Attachment, Route Tables and Subnet Route Table Association.",
      InScope: false,
      Name: "Public VPC",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/vpc_public/vpc_public_permission.json",
      SubCategory: "Networking and Content Delivery",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "f98cdc79-cca0-5dc6-8028-4919db3e0f3c",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "Amazon S3 Glacier Instant Retrieval Service is ideal for archive data that needs immediate access, such as medical images, news media assets, or user-generated content archives. This Storage delivers lowest cost for long-lived data that is rarely accessed and requires retrieval in milliseconds.",
      InScope: false,
      Name: "Storage Service Glacier Instant Retrieval",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/storage_service_glacierinstantretrival/StorageServiceGlacierInstantRetrival.json",
      SubCategory: "Storage",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: "ffd4831f-ace2-5a7c-8a0e-dc3bbf77bf67",
      Category: "Infrastructure",
      CostEstimate: null,
      CostEstimateId: null,
      Description:
        "This blueprint will generate the sagemaker notebook instance to help researchers in their analysis.",
      InScope: true,
      Name: "AlphaFold Sagemaker Notebook",
      Owner: "MontyCloud",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/alphafold_sagemaker_notebook/AlphaFoldSagemakerPermission.json",
      SubCategory: "Compute",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: "CFN",
      Depts: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: TERRAFORM_COMPLETED_BP_ID,
      Category: "Infrastructure",
      CostEstimateId: null,
      InScope: true,
      Name: "Analytics and Data Insights Accelerator", // s3
      Description:
        "Deploy an integrated Data Insights Platform featuring Elasticsearch, EC2, Lambda, S3 buckets, and RDS. Achieve high availability, fault tolerance, auto-scaling with network optimization monitoring and ops automation along with security best practices . Utilize Elasticsearch for analytics, EC2 for processing, Lambda for serverless compute, S3 for storage, and RDS for structured data management.",
      Owner: "Customer",
      PermissionCFNURL:
        "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/alphafold_sagemaker_notebook/AlphaFoldSagemakerPermission.json",
      SubCategory: "Compute",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: TERRAFORM,
      Depts: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
      Status: "Completed",
      CostEstimate: 120,
    },
    {
      AccessLevel: "Regular",
      AvailableInPlan: true,
      BlueprintId: TERRAFORM_DRAFT_BP_ID,
      Category: "Server Blueprints",
      CostEstimateId: null,
      InScope: true,
      Name: "EC2 Linux Instance - Terraform",
      Description: "Provisions an Amazon Linux EC2 Instance",
      Owner: "Customer",
      PermissionCFNURL: "",
      SubCategory: "Compute",
      SupportedProducts: ["02d20664-d01e-5a4f-8059-4dd3c5b24bf7"],
      Type: TERRAFORM,
      Depts: [],
      Status: "Draft",
      CostEstimate: null,
    },
  ];

  allBlueprints.forEach(function (element) {
    element.AvailableInPlan = true;
    if (!element.BlueprintId) {
      element.BlueprintId = uuidv4();
    }
    if (!element.SupportedProducts) {
      element.SupportedProducts = [PRODUCT_ID_WMC];
    }
    if (!category.includes(element.Category)) {
      element.Category = faker.helpers.arrayElement(category);
    }
    if (!element.Type) {
      element.Type = faker.helpers.arrayElement(type);
    }
    if (!element.Owner) {
      element.Owner = faker.helpers.arrayElement(owner);
    }
    if (
      ![TERRAFORM_DRAFT_BP_ID, TERRAFORM_COMPLETED_BP_ID].includes(
        element.BlueprintId
      )
    ) {
      element.CostEstimate = faker.number.int({
        min: 45,
        max: 70,
      });
    }
  });

  if (deptIds) {
    return allBlueprints.filter(
      (blueprint) => _.intersection(deptIds, blueprint.Depts).length > 0
    );
  }

  return allBlueprints;
};

export const createBlueprintCategory = (newCategory) => {
  return {
    ID: uuidv4(),
    Name: newCategory.Category,
  };
};

export const shareBlueprint = (blueprintId, data, listShares) => {
  const newShares = data.OrganizationIds.map((orgId) => {
    return {
      AppCount: 0,
      BlueprintId: blueprintId,
      LastStatus: null,
      LastUsed: null,
      OrganizationId: orgId,
      ShareStatus: "SHARE_SUCCESS",
    };
  });

  return [...listShares, ...newShares];
};

export const unshareBlueprint = (blueprintId, data, listShares) => {
  const bpShares = listShares.filter(
    (share) => share.BlueprintId === blueprintId
  );
  const updatedShares = bpShares.filter(
    (tenant) => !data.OrganizationIds.includes(tenant.OrganizationId)
  );

  return updatedShares;
};
